module.exports = __webpack_public_path__ + "img/system2.d608e6cd.png";